import styled from '@emotion/styled';

export const SubTaskButtonContainer = styled('div')<{
  center?: boolean;
}>((p) => ({
  display: 'flex',
  justifyContent: p.center ? 'center' : 'left',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: p.theme.spacing(0.5)
}));
